module.exports = __webpack_public_path__ + "static/media/ScienceTech_PictoCdlT.7fe8acd0.png";